import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyD5GgrX5xYlqKPucLdNF6oaSjNA2BHP1UA",
  authDomain: "picklerank-38bd7.firebaseapp.com",
  projectId: "picklerank-38bd7",
  storageBucket: "picklerank-38bd7.firebasestorage.app",
  messagingSenderId: "302237764308",
  appId: "1:302237764308:web:76ab919dacc5e26a0d8941"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export default app;
